/**
 * Copies table data to clipboard in a format suitable for Excel/Google Sheets.
 * @param {Array} headers - Array of column headers
 * @param {Array} rows - Array of row objects
 * @param {Array} keys - Array of keys corresponding to headers in row objects
 */
export const copyTableToClipboard = (headers, rows, keys) => {
    const headerRow = headers.join('\t');
    const bodyRows = rows.map(row => {
        return keys.map(key => {
            let value = row[key];
            if (value === null || value === undefined) return '';
            // Handle newlines in cells by replacing them with spaces or removing them
            return String(value).replace(/(\r\n|\n|\r)/gm, " ");
        }).join('\t');
    }).join('\n');

    const csvContent = `${headerRow}\n${bodyRows}`;

    navigator.clipboard.writeText(csvContent).then(() => {
        // Optional: You could show a toast notification here if you had a toast system
        console.log('Table copied to clipboard');
    }).catch(err => {
        console.error('Failed to copy table: ', err);
    });
};

/**
 * Copies table data to clipboard in JSON format, lowercasing keys to match API POST requirements.
 * @param {Array} rows - Array of row objects
 */
export const copyTableAsJSON = (rows) => {
    const jsonRows = rows.map(row => {
        const jsonRow = {};
        Object.entries(row).forEach(([key, value]) => {
            const lowerKey = key.toLowerCase();
            // skip specific internal or standard react fields if necessary
            if (lowerKey === 'next_fetch') return;
            jsonRow[lowerKey] = value;
        });
        return jsonRow;
    });

    const jsonContent = JSON.stringify(jsonRows, null, 2);

    navigator.clipboard.writeText(jsonContent).then(() => {
        console.log('JSON copied to clipboard');
    }).catch(err => {
        console.error('Failed to copy JSON: ', err);
    });
};
